import {
  Button,
  Card,
  CardBody,
  CardImg,
  Col,
  Modal,
  ModalBody,
  Progress,
  Row,
  Spinner,
  Table,
  Tooltip,
} from "reactstrap"
import {api} from "../../../utils/variables"
import axios from "axios"
import { useEffect, useState } from "react"
import { isNumber } from "lodash"
import { FaAngleDoubleUp, FaAngleDoubleDown, FaEquals } from "react-icons/fa"
import Apaexlinecolumn from "../../common/charts-graphs/ApexLineChart"
import { AnimatePresence, motion } from "framer-motion"
import { Link } from "react-router-dom"
import { Info } from "react-feather"
import GraphTrends from "../../common/Modals/GraphTrends"
import { generateSlug } from "../../../utils/seoUtils"

const DataGraphTable = ({ keywordData, ctype }) => {
  const gameData = keywordData?.game_data

  const [graphData, setGraphData] = useState([])
  const [localGraphData, setLocalGraphData] = useState([])
  const [graphLoader, setGraphLoader] = useState(false)
  const [topApps, setTopApps] = useState({})
  const [selectedKeyword, setSelectedKeyword] = useState("")
  const [sortedRows, setSortedRows] = useState([])
  const [created, setCreated] = useState(null)
  const [searchQuery, setSearchQuery] = useState("")
  const [tright, settright] = useState(false)

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  })
  const [expandedRowValue, setExpandedRowValue] = useState(null)
  const [expandedRowIndex, setExpandedRowIndex] = useState(null)
  const [modal_toggle, setmodal_toggle] = useState(false)
  const [graphInfoModel, setGraphInfoModel] = useState(false)

  const filteredRows = sortedRows.filter(row =>
    row.Keywords.toLowerCase().includes(searchQuery.toLowerCase())
  )
  const [selectedOption, setSelectedOption] = useState("")

  const toggleExpandRow = index => {
    setExpandedRowIndex(expandedRowIndex === index ? null : index)
    // Reset checkedItems when expanding a row
    if (expandedRowIndex !== index) {
      setCheckedItems(["Rank", "Revenue", "Downloads"])
    }
  }
  const formatDateToYYYYMMDD = date => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0") // Add 1 to month (0-indexed) and pad with leading zero
    const day = String(date.getDate()).padStart(2, "0") // Pad day with leading zero if necessary
    return `${year}-${month}-${day}`
  }
  const oneMonthBack = date => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1 - 1).padStart(2, "0") // Add 1 to month (0-indexed) and pad with leading zero
    const day = String(date.getDate()).padStart(2, "0") // Pad day with leading zero if necessary
    return `${year}-${month}-${day}`
  }
  const [startDate, setStartDate] = useState(oneMonthBack(new Date()))
  const [endDate, setEndDate] = useState(formatDateToYYYYMMDD(new Date()))

  const toggle_modal = () => {
    setmodal_toggle(prev => !prev)
  }

  const toogleGraphInfo = () => {
    setGraphInfoModel(prev => !prev)
  }

  const [checkedItems, setCheckedItems] = useState([
    "Rank",
    "Revenue",
    "Downloads",
  ])

  // This function will add or remove items from the array based on the checkbox state
  const handleCheckboxChange = (e, itemText) => {
    if (e.target.checked) {
      // Add itemText to the array
      setCheckedItems(prevItems => [...prevItems, itemText])
    } else {
      // Remove itemText from the array
      setCheckedItems(prevItems => prevItems.filter(item => item !== itemText))
    }
  }
  const sortRows = field => {
    const newDirection =
      sortConfig.key === field && sortConfig.direction === "asc"
        ? "desc"
        : "asc"

    const sorted = [...sortedRows].sort((a, b) => {
      if (typeof a[field] === "string") {
        return newDirection === "asc"
          ? a[field].localeCompare(b[field])
          : b[field].localeCompare(a[field])
      } else {
        return newDirection === "asc"
          ? a[field] - b[field]
          : b[field] - a[field]
      }
      return 0 //fallback case
    })

    setSortedRows(sorted)
    setSortConfig({ key: field, direction: newDirection })
  }
  const getGraphData = async (keyword, gameId, ctype) => {
    setGraphLoader(true)
    const data = {
      type: ctype == "Cat" ? "category" : "keyword",
      entity_id: keyword,
      game_id: gameId,
      start_date: startDate,
      end_date: endDate,
    }
    try {
      const res = await axios.post(
        `${api}/tracker/tracking/keyword_details`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      setGraphData(res.data.data.rankings)
    } catch (error) {
      console.log(error)
    } finally {
      setGraphLoader(false)
      setCheckedItems(["Rank", "Revenue", "Downloads"])
    }
  }

  const getLocalGraphData = async (gameId, ctype) => {
    setGraphLoader(true)
    const data = {
      type: ctype == "Cat" ? "category" : "keyword",
      // entity_id: keyword,
      //game_id: gameId,
      item_id: gameId,
      start_date: startDate,
      end_date: endDate,
    }
    try {
      const res = await axios.post(`${api}/tracker/tracking/app_graph`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      setLocalGraphData(res.data.history)
      //setGraphData(res.data.history)
      // console.log(res.data.data.rankings)
    } catch (error) {
      console.log(error)
    } finally {
      setGraphLoader(false)
      setCheckedItems(["Rank", "Revenue", "Downloads"])
    }
  }
  useEffect(() => {
    const keyword = expandedRowValue
    const gameId = Object.values(keywordData)[expandedRowIndex]?.game
    getGraphData(keyword, gameId, ctype)
  }, [expandedRowIndex, expandedRowValue])

  useEffect(() => {
    if (Object.keys(keywordData).length > 0) {
      setSortedRows(
        Object.values(keywordData)
          .slice(0, -1)
          .map((keyword, index) => {
            if (index == 0) {
              setCreated(keyword?.update_time)
            }
            const historicalData = keyword?.matching_historical_data
            const gameType = historicalData?.at(-1)?.platform

            const secondLastRank =
              historicalData?.length > 0 &&
                historicalData?.at(-1)?.ranks[keyword?.game]
                ? Number(historicalData.at(-1).ranks[keyword?.game])
                : gameType === "meta"
                  ? "> 10"
                  : "> 10"

            const lastRank =
              historicalData?.length > 0 &&
                historicalData?.at(-2)?.ranks[keyword?.game]
                ? Number(historicalData.at(-2).ranks[keyword?.game])
                : gameType === "meta"
                  ? "> 10"
                  : "> 10"

            let rankChange = "No Change"
            if (isNumber(lastRank) && isNumber(secondLastRank)) {
              rankChange = lastRank - secondLastRank
              rankChange = rankChange > 0 ? `+${rankChange}` : `${rankChange}`
            }
            if (historicalData.length > 0) {
              return {
                Keywords: ctype == "Cat" ? keyword?.category : keyword?.keyword,
                Position: lastRank,
                cPos: isNumber(lastRank) ? lastRank : 99999,
                LastPosition: secondLastRank,
                lPos: isNumber(secondLastRank) ? secondLastRank : 99999,
                Change:
                  rankChange == "No Change" ? (
                    rankChange
                  ) : rankChange < 0 ? (
                    <>
                      <FaAngleDoubleUp color="green" />
                      <span className="align-middle">{rankChange}</span>
                    </>
                  ) : rankChange == 0 ? (
                    <div>
                      <FaEquals color="yellow" />
                      <span className="align-middle"> {rankChange}</span>
                    </div>
                  ) : (
                    <>
                      <FaAngleDoubleDown color="red" />
                      <span className="align-middle">{rankChange}</span>
                    </>
                  ),
                changePos:
                  rankChange == "No Change"
                    ? 99999
                    : Number(lastRank - secondLastRank),
                Popularity: <Progress style={{ backgroundColor: '#e9ecef' }} // background of the bar track
                  barStyle={{ backgroundColor: '#F6255A' }} // color of the filled bar (if using Reactstrap >=9)
                  value="70" />,
                Competitiveness: <Progress style={{ backgroundColor: '#e9ecef' }} // background of the bar track
                  barStyle={{ backgroundColor: '#F6255A' }} // color of the filled bar (if using Reactstrap >=9)
                  value="60" />,
                Topapps: (
                  <Button
                    className="pink-btn"
                    onClick={() => {
                      toggle_modal()
                      setTopApps(historicalData?.at(-1)?.ranks)
                      setSelectedKeyword(keyword?.keyword)
                    }}
                  >
                    Live Ranking
                  </Button>
                ),
              }
            } else {
              return {
                Keywords: ctype == "Cat" ? keyword?.category : keyword?.keyword,
                Position: "Loading",
                cPos: isNumber(lastRank) ? lastRank : 99999,
                LastPosition: "Loading",
                lPos: isNumber(secondLastRank) ? secondLastRank : 99999,
                Change:
                  rankChange == "No Change" ? (
                    rankChange
                  ) : rankChange < 0 ? (
                    <>
                      <FaAngleDoubleUp color="green" />
                      <span className="align-middle">{rankChange}</span>
                    </>
                  ) : rankChange == 0 ? (
                    <div>
                      <FaEquals color="yellow" />
                      <span className="align-middle"> {rankChange}</span>
                    </div>
                  ) : (
                    <>
                      <FaAngleDoubleDown color="red" />
                      <span className="align-middle">{rankChange}</span>
                    </>
                  ),
                changePos:
                  rankChange == "No Change"
                    ? 99999
                    : Number(lastRank - secondLastRank),
                Popularity: <Progress color="info" value="70" />,
                Competitiveness: <Progress color="info" value="60" />,
                Topapps: (
                  <Button
                    color="secondary"
                    disabled="true"
                    onClick={() => {
                      toggle_modal()
                      setTopApps(historicalData?.at(-1)?.ranks)
                      setSelectedKeyword(keyword?.keyword)
                    }}
                  >
                    Live Ranking
                  </Button>
                ),
              }
            }
          })
          .flat() // Flatten the array to ensure proper structure
      )
    }
  }, [keywordData])

  function convertEpochToDate(epochTime) {
    const date = new Date(epochTime * 1000) // Multiply by 1000 to convert from seconds to milliseconds

    const day = String(date.getDate()).padStart(2, "0") // Get day and pad with zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0") // Get month (0-based, so add 1)
    const year = date.getFullYear().toString().slice(-4) // Get last 2 digits of the year
    const hours = String(date.getHours()).padStart(2, "0") // Get hours
    const minutes = String(date.getMinutes()).padStart(2, "0") // Get minutes

    // Format the date as dd-mm-yy hh:mm
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`

    return formattedDate
  }
  const handleChange = event => {
    const selected = event.target.value
    setSelectedOption(selected)
    applyFilter(selected)
  }

  const applyFilter = selected => {
    if (selected === "Local") {
      getLocalGraphData(
        Object.values(keywordData)[expandedRowIndex]?.game,
        ctype
      )
    } else {
      getGraphData(
        expandedRowValue,
        Object.values(keywordData)[expandedRowIndex]?.game,
        ctype
      )
    }
  }

  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between">
        <p className="mb-0 mt-2">
          Last Updated: {convertEpochToDate(created)} UTC
        </p>
        <Col className="col-md-3">
          <input
            type="text"
            placeholder="Search Keywords..."
            className="form-control mb-3"
            value={searchQuery}
            onChange={e => {
              setExpandedRowIndex(null)
              setSearchQuery(e.target.value)
            }}
          />
        </Col>
      </div>
      <div className="table-responsive">
        <Table className="border" style={{
          borderRadius: "20px",
          overflow: "hidden"
        }}>
          <thead>
            <tr>
              <th

                onClick={() => {
                  setExpandedRowIndex(null)
                  sortRows("Keywords")
                }}
                style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "30px" }}
              >
                {ctype == "Cat" ? "Category" : "Keyword"}
              </th>
              <th
                onClick={() => {
                  setExpandedRowIndex(null)
                  sortRows("cPos")
                }}
                style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "30px" }}
              >
                Current Position
              </th>
              <th
                onClick={() => {
                  setExpandedRowIndex(null)
                  sortRows("lPos")
                }}
                style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "30px" }}
              >
                Last Position
              </th>
              <th
                onClick={() => {
                  setExpandedRowIndex(null)
                  sortRows("changePos")
                }}
                style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "30px" }}
              >
                Change
              </th>
              <th style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "30px" }}>Popularity</th>
              <th style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "30px" }}>Competitiveness</th>
              <th style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "30px" }}>Live Ranking</th>
            </tr>
          </thead>
          <tbody>
            {filteredRows.map((row, index) => (
              <>
                <tr key={index}>
                  <td
                    onClick={() => {
                      toggleExpandRow(index)
                      setExpandedRowValue(row.Keywords)
                    }}
                    style={{ cursor: "pointer", backgroundColor: "#2C2D33", color: "#FFFFFF", fontSize: "30px" }}
                  >
                    <strong> {row.Keywords}</strong>
                  </td>
                  <td style={{ cursor: "pointer", backgroundColor: "#2C2D33", color: "#FFFFFF", fontSize: "30px" }}>{row.Position}</td>
                  <td style={{ cursor: "pointer", backgroundColor: "#2C2D33", color: "#FFFFFF", fontSize: "30px" }}>{row.LastPosition}</td>
                  <td style={{ cursor: "pointer", backgroundColor: "#2C2D33", color: "#FFFFFF", fontSize: "30px" }}>{row.Change}</td>
                  <td style={{ cursor: "pointer", backgroundColor: "#2C2D33", color: "#FFFFFF", fontSize: "30px" }}>{row.Popularity}</td>
                  <td style={{ cursor: "pointer", backgroundColor: "#2C2D33", color: "#FFFFFF", fontSize: "30px" }}>{row.Competitiveness}</td>
                  <td style={{ cursor: "pointer", backgroundColor: "#2C2D33", color: "#FFFFFF", fontSize: "30px" }}>{row.Topapps}</td>
                </tr>
                <AnimatePresence>
                  {expandedRowIndex === index && (
                    <tr key={`expanded-${index}`} className="text-align-center">
                      <td colSpan="7">
                        {/* You can render any additional content here */}

                        {expandedRowIndex !== null && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{
                              height: 0,
                              opacity: 0,
                              transition: { duration: 0.4, ease: "easeInOut" },
                            }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            className="bg-dark"
                            style={{
                              padding: "10px",
                              margin: "10px",
                              zIndex: 100,
                              overflow: "hidden",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                            }}
                          >
                            <p className="m-3">
                              {ctype == "Cat" ? "Category" : "Keyword"}:{" "}
                              <b>{expandedRowValue}</b>
                            </p>

                            <Row className="m-3">
                              <div className="d-flex flex-wrap justify-content-between">
                                <div className="d-flex flex-wrap gap-4">
                                  <label
                                    htmlFor="start-date-input"
                                    className="col-form-label"
                                  >
                                    From
                                  </label>
                                  <div className="">
                                    <input
                                      className="form-control"
                                      type="date"
                                      defaultValue={startDate}
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onChange={e => {
                                        setStartDate(e.target.value)
                                      }}
                                      id="start-date-input"
                                    />
                                  </div>
                                </div>

                                <div className="d-flex flex-wrap gap-4">
                                  <label
                                    htmlFor="end-date-input"
                                    className="col-form-label"
                                  >
                                    To
                                  </label>
                                  <div className="">
                                    <input
                                      className="form-control"
                                      type="date"
                                      defaultValue={endDate}
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      onChange={e => {
                                        setEndDate(e.target.value)
                                      }}
                                      id="end-date-input"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <select
                                    className="form-control"
                                    onChange={handleChange}
                                  >
                                    <option value="Global">
                                      Global Revenue/Downloads
                                    </option>
                                    <option value="Local">
                                      App Revenue/Downloads
                                    </option>
                                  </select>
                                </div>
                                <Button
                                  color="primary"
                                  onClick={() => applyFilter(selectedOption)}
                                >
                                  Apply Range
                                </Button>
                              </div>
                            </Row>
                            {graphLoader ? (
                              <div className="d-flex justify-content-center">
                                <Spinner></Spinner>
                              </div>
                            ) : (
                              <>
                                <div className="m-4 d-flex justify-content-start gap-5">
                                  <div className="d-flex flex-wrap justify-content-start gap-3">
                                    <label>
                                      <input
                                        type="checkbox"
                                        defaultChecked="true"
                                        onChange={e =>
                                          handleCheckboxChange(e, "Rank")
                                        }
                                      />
                                      Rank
                                    </label>
                                    <label>
                                      <input
                                        type="checkbox"
                                        defaultChecked="true"
                                        onChange={e =>
                                          handleCheckboxChange(e, "Revenue")
                                        }
                                      />
                                      Revenue
                                    </label>
                                    <label>
                                      <input
                                        type="checkbox"
                                        defaultChecked="true"
                                        onChange={e =>
                                          handleCheckboxChange(e, "Downloads")
                                        }
                                      />
                                      Downloads
                                    </label>
                                  </div>
                                  <Tooltip
                                    placement="right"
                                    isOpen={tright}
                                    target="TooltipRight"
                                    toggle={() => {
                                      settright(!tright)
                                    }}
                                  >
                                    Click to learn more about graph trends
                                  </Tooltip>
                                  <Info
                                    id="TooltipRight"
                                    size={20}
                                    onClick={() => {
                                      toogleGraphInfo()
                                    }}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                                <Apaexlinecolumn
                                  data={graphData}
                                  selectedData={selectedOption}
                                  localData={localGraphData}
                                  labels={checkedItems}
                                />
                              </>
                            )}
                          </motion.div>
                        )}
                      </td>
                    </tr>
                  )}
                </AnimatePresence>
              </>
            ))}
          </tbody>
        </Table>
      </div>
      <Modal
        isOpen={modal_toggle}
        toggle={() => {
          toggle_modal()
        }}
        centered
        size="md"
        style={{ maxHeight: "100vh" }}
      >
        <div className="modal-header bg-gradient-primary">
          <div className="d-flex justify-content-start gap-2 align-items-center">
            {/* <FaLock></FaLock> */}
            <h5 className="modal-title" id="staticBackdropLabel">
              Live Ranking in {selectedKeyword}
            </h5>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              toggle_modal()
            }}
            aria-label="Close"
          ></button>
        </div>
        <ModalBody
          className=""
          style={{
            maxHeight: "80vh",
            // minHeight: "40vh",
            padding: "20px",
            overflowY: "auto",
          }}
        >
          <div>
            <Row className="pb-2">
              <Col lg={12}>
                <Card className="mb-1">
                  {topApps && Object.keys(topApps).length === 0 ? (
                    <p>NO DATA</p>
                  ) : topApps ? (
                    Object.entries(topApps)
                      .sort(([, rankA], [, rankB]) => rankA - rankB) // Sort by rank in ascending order
                      .map(([app, rank], index) => {
                        const gameDetails = gameData.find(
                          game => game.item_id === app
                        ) // Find game by item_id
                        return (
                          <Link
                            to={`/xr/app/${generateSlug(gameDetails?.name || '')}?id=${gameDetails?.item_id}`}
                            className=""
                            state={{
                              app_id: gameDetails?.item_id,
                              data: gameDetails,
                            }}
                          >
                            <Row
                              className="g-0 align-items-center app-card-container2"
                              key={index}
                            >
                              <Col md={4}>
                                <CardImg
                                  className="img-fluid p-2"
                                  src={
                                    gameDetails?.image_url ||
                                    "https://via.placeholder.com/50"
                                  }
                                  alt="image cap"
                                  style={{
                                    minHeight: 70,
                                    maxHeight: 70,
                                    minWidth: 120,
                                    maxWidth: 120,
                                    objectFit: "cover",
                                  }}
                                />
                              </Col>
                              <Col md={8}>
                                <CardBody>
                                  <div className="d-flex justify-content-between">
                                    <b className="">
                                      <p>{gameDetails?.name || "Demo"}</p>
                                    </b>
                                    <p>{rank}</p>
                                  </div>
                                </CardBody>
                              </Col>
                            </Row>
                          </Link>
                        )
                      })
                  ) : (
                    <p>Loading...</p>
                  )}
                </Card>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </Modal>
      <GraphTrends modaltoggle={graphInfoModel} togglemodal={toogleGraphInfo} />
    </div>
  )
}

export default DataGraphTable
